import React from 'react';

import classnames from 'clsx';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { CollapsibleListSection } from 'ui-components/components/collapsible-list/collapsible-list-section';
import { CollapsibleListSectionContent } from 'ui-components/components/collapsible-list/collapsible-list-section-content';
import { CollapsibleListSectionHeader } from 'ui-components/components/collapsible-list/collapsible-list-section-header';
import { noop } from 'ui-components/default-props/noop';

import { CustomsPropType } from '../../prop-types/customs';
import { CustomsErrorBadge } from './components/error-badge';
import { CustomsProvider } from './context/context';
import CustomsDeclarationsWidget from './customs-declarations-widget';
import { getCustomsItemsCount } from './get-customs-item-count';

import { messages } from './messages';

import style from './style.module.css';

const CustomsDeclarations = ({
  fulfillmentPlanId = null,
  open = false,
  onClick = noop,
  dragHandleProps,
  customs,
  readOnly = false,
  saveCustoms = noop,
  defaultCountryCode = '',
  defaultCurrencyCode = '',
  defaultWeightUnit = '',
  needsCustoms,
  className = null,
  noIcon = false,
}) => {
  const classes = classnames(style['customs-collapsible-wrapper'], className);
  const { customsItems = [] } = customs;

  if (!needsCustoms || !customsItems.length) {
    return null;
  }

  return (
    <div key={fulfillmentPlanId} className={classes}>
      <CustomsProvider
        customs={customs}
        defaultCountryCode={defaultCountryCode}
        defaultCurrencyCode={defaultCurrencyCode}
        defaultWeightUnit={defaultWeightUnit}
        fulfillmentPlanId={fulfillmentPlanId}
        saveCustoms={saveCustoms}
      >
        <CollapsibleListSection open={open}>
          <CollapsibleListSectionHeader
            dragHandleProps={dragHandleProps}
            noIcon={noIcon}
            onClick={() => onClick(open)}
            summaryData={`${getCustomsItemsCount(customsItems)}`}
            theme='white'
          >
            <FormattedMessage {...messages.customsHeader} />
            <div className={style['error-badge']}>{!readOnly && <CustomsErrorBadge />}</div>
          </CollapsibleListSectionHeader>
          <CollapsibleListSectionContent>
            <CustomsDeclarationsWidget fulfillmentPlanId={fulfillmentPlanId} readOnly={readOnly} />
          </CollapsibleListSectionContent>
        </CollapsibleListSection>
      </CustomsProvider>
    </div>
  );
};

CustomsDeclarations.propTypes = {
  fulfillmentPlanId: PropTypes.string,
  open: PropTypes.bool,
  onClick: PropTypes.func,
  dragHandleProps: PropTypes.object,
  readOnly: PropTypes.bool,
  customs: CustomsPropType.isRequired,
  saveCustoms: PropTypes.func,
  defaultCountryCode: PropTypes.string,
  defaultCurrencyCode: PropTypes.string,
  defaultWeightUnit: PropTypes.string,
  needsCustoms: PropTypes.bool.isRequired,
  className: PropTypes.string,
  noIcon: PropTypes.bool,
};

export default CustomsDeclarations;
